<template>
  <div class="header__search">
    <div class="searchbar--text-above" style="white-space: nowrap">{{header_text}}</div>
    <div class="search">
      <form autocomplete="off" action="" class="search__body">
        <div class="search__shadow searchbar--OR" v-if="has_search_vehicle == true"><i>OR</i></div>

        <!-- <input class="search__input" type="text" placeholder="Search 11" v-model="searchkeyword" @keypress.enter="keywordSearch" /> -->
        <type-ahead @selectedSearch="keywordSearch"></type-ahead>

        <button class="search__button search__button--start" type="button" v-if="has_search_vehicle == true" @click="openVehicleSearch" :class="vehicleSearchButtonClass">
        <!-- <button class="search__button search__button--start" type="button"> -->
          <span class="search__button-icon">
            <svg width="20" height="20" class="search-svg">
              <path d="M6.6,2c2,0,4.8,0,6.8,0c1,0,2.9,0.8,3.6,2.2C17.7,5.7,17.9,7,18.4,7C20,7,20,8,20,8v1h-1v7.5c0,0.8-0.7,1.5-1.5,1.5h-1 	c-0.8,0-1.5-0.7-1.5-1.5V16H5v0.5C5,17.3,4.3,18,3.5,18h-1C1.7,18,1,17.3,1,16.5V16V9H0V8c0,0,0.1-1,1.6-1C2.1,7,2.3,5.7,3,4.2 	C3.7,2.8,5.6,2,6.6,2z M13.3,4H6.7c-0.8,0-1.4,0-2,0.7c-0.5,0.6-0.8,1.5-1,2C3.6,7.1,3.5,7.9,3.7,8C4.5,8.4,6.1,9,10,9 	c4,0,5.4-0.6,6.3-1c0.2-0.1,0.2-0.8,0-1.2c-0.2-0.4-0.5-1.5-1-2C14.7,4,14.1,4,13.3,4z M4,10c-0.4-0.3-1.5-0.5-2,0 	c-0.4,0.4-0.4,1.6,0,2c0.5,0.5,4,0.4,4,0C6,11.2,4.5,10.3,4,10z M14,12c0,0.4,3.5,0.5,4,0c0.4-0.4,0.4-1.6,0-2c-0.5-0.5-1.3-0.3-2,0 	C15.5,10.2,14,11.3,14,12z" />
            </svg>
          </span>
          <!-- <span class="search__button-title">Search for Parts by Vehicle</span> -->
          <span class="search__button-title">{{ catalogCaption }}</span>
        </button>
        
        <div class="search__box"></div>
        <div class="search__decor">
          <div class="search__decor-start"></div>
          <div class="search__decor-end"></div>
        </div>
        <div class="search__dropdown search__dropdown--vehicle-picker vehicle-picker" :class="vehicleSearchContainerClass" v-click-outside="closeVehiclePopup">
          <div class="search__dropdown-arrow"></div>
          <div class="vehicle-picker__panel vehicle-picker__panel--form" data-panel="form" :class="vehicleSearchPanelClass">
            <div class="vehicle-picker__panel-body">
              <div class="vehicle-form vehicle-form--layout--search">
                <div class="vehicle-form__item vehicle-form__item--select">
                  <!-- <span>{{captionYear}}</span> -->
                  <select class="form-control" v-model="selectedyear" @change="getMakes();clearPlink()">
                    <option value="" aria-placeholder="Select Year">{{captionYear}}</option>
                    <option v-for="year in years" :key="year">
                        {{ year.year }}
                    </option>
                  </select>
                </div>
                <div class="vehicle-form__item vehicle-form__item--select" v-if="storeCatalog === 'WHI'">
                  <!-- <span>Select Make</span> -->
                  <select
                    class="form-control"
                    aria-label="Brand" v-model="selectedmake" @change="getModels"
                    :disabled="selectedyear === 0"
                  >
                    <option value="" aria-placeholder="Select Make">Select Make</option>
                    <option v-for="make in makes" :key="make.make" :value="make.make" class="notranslate">
                        {{ make.desc }}
                    </option>
                  </select>
                </div>
                <div class="vehicle-form__item vehicle-form__item--select" v-if="storeCatalog === 'WHI'">
                  <select class="form-control" aria-label="Model" v-model="selectedmodel" @change="getEngines" :disabled="selectedmake === ''">
                    <option value="" aria-placeholder="Select Model">Select Model</option>
                    <option v-for="model in models" :key="model.model" :value="model.model" class="notranslate" :data-make="model.make">
                        {{ model.desc }}
                    </option>
                  </select>
                </div>
                <model-autocomplete v-else elemid="headersearch" :_models="models" @model_selected="plink_model" ref="plink_autocomplete"  @error_sel="error_sel"></model-autocomplete>
                <div class="vehicle-form__item vehicle-form__item--select"  v-if="storeCatalog === 'WHI'">
                  <select class="form-control" aria-label="Engine" v-model="selectedengine" :disabled="selectedmodel === ''">
                    <option value="" aria-placeholder="Select Engine">Select Engine</option>
                    <option v-for="engine in engines" :key="engine.engine" :value="engine.engine" class="notranslate">
                        {{ engine.desc }}
                    </option>
                  </select>
                </div>
                <div class="vehicle-form__divider">Or</div>
                <div class="vehicle-form__item">
                  <table>
                    <tbody>
                      <tr>
                        <!-- <td>
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Enter License Plate"
                            aria-label="License Plate"
                          />
                        </td> -->
                        <!-- <td>
                          <image src="images/spacer.png" width="8px"> </image>
                        </td> -->
                        <td colspan="2" class="p-0">
                          <input
                            type="text"
                            class="form-control form-control-search-parts-vin-modal-1"
                            :placeholder="searchstr_placeholder"
                            aria-label="VIN number"
                            v-model="vinnumber" />
                          <span v-if="storeCatalog == 'PARTSLINK'"><b>Search by:</b> Vehicle, Group, Part Number or OE Number</span>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="vehicle-picker__actions">
                <!-- <button type="button" class="btn btn-primary btn-sm" data-to-panel="list"> -->
                <button type="button" class="btn btn-secondary btn-sm" data-to-panel="list" v-if="this.userIsAuthenticated" @click="openVehicleListPanel">
                  View Saved Vehicles
                </button>
                <button type="button" class="btn btn-primary btn-sm" @click.prevent="searchNewParts" >
                    Search Parts
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="vehicle-picker__panel vehicle-picker__panel--list" data-panel="list"> -->
          <div class="vehicle-picker__panel vehicle-picker__panel--list" data-panel="list" :class="vehicleListPanelClass">
            <div class="vehicle-picker__panel-body">
              <div class="vehicle-picker__text">
                Select a vehicle to find exact fit parts
              </div>
              <saved-vehicles @cancel-saved-vehicles="cancelSavedVehicles" @close-panel="closePanel"></saved-vehicles>
            </div>
          </div>
        </div>
        
        <button class="search__button search__button--start" type="button" v-if="has_mailing_form == true" @click="ismailingformopen = !ismailingformopen" :class="mailingFormButtonClass">
            <span class="search__button-title">Mailing List Signup</span>
        </button>

        <mailing-form :ismailingformopen="ismailingformopen" v-click-outside="closeMailingFormPopup"></mailing-form>
      </form>
    </div>
  </div>
  <!-- <base-dialog title="Invalid Search" @close="closeDialog" :open="searchvalid === false"> -->
  <base-dialog title="Invalid Search" @close="closeMessageDialog" :open="vehiclemessages.length > 0" :new-class="'dialog-vehicle-messages'">
    <template #default>
      <!-- <p>{{ searchErrorNote }}</p> -->
      <ul class="list-unstyled">
        <li v-for="messages in vehiclemessages" :key="messages">
          {{ messages }}
        </li>
      </ul>
    </template>
    <template #actions>

    </template>
  </base-dialog>
</template>

<script>
import SavedVehicles from '../../common/vehicle/SavedVehicles';
import ModelAutocomplete from '../../common/vehicle/ModelAutocomplete.vue';
import TypeAhead from './TypeAhead.vue';
// import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';
import VehicleSearch from '../../../mixins/vehicle_search.js';
import MailingForm from './MailingForm.vue';
// import { sfCustom } from '../../../utilities/customs';

export default {
  components: {
    "saved-vehicles": SavedVehicles,
    'type-ahead' : TypeAhead,
    MailingForm,
    ModelAutocomplete
  },
  data() {
      return {
          captionYear: 'Select Year',
          selectedyear: '',
          selectedmake: '',
          selectedmodel: '',
          selectedengine: '',
          years: [],
          makes: [],
          models: [],
          engines: [],
          searchvalid: null,
          searchkeyword: '',
          vin_number: null,
          isvehiclepanelopen: false,
          vehiclepanelopen: 'search',

          ismailingformopen: false,
      }
  },
  mixins: [VehicleSearch],
  methods: {
      closeMessageDialog() {
        this.vehiclemessages = [];
      },

      keywordSearch(selectedItem = '') {

        // hardcoded for kit item
        // need to identify how product being parts or a kit
        // if(selectedItem == 'GK350R'){
        //   this.$router.push('/kit-group/' + selectedItem);
        //   return;  
        // }

        let searchtext = encodeURIComponent(selectedItem);
        this.searchkeyword = '';
        this.$router.push('/keyword-search-results?search=' + searchtext);
      },
      openVehicleSearch() {
        if(this.$route.name == 'SearchResults'){
          this.selectedyear = '';
          this.selectedmake = '';
          this.selectedmodel = '';
          this.selectedengine = '';
          this.vinnumber = '';
          this.plink_model = '';
        }
        this.isvehiclepanelopen = true;
        this.vehiclepanelopen = 'search';
        
      },
      openVehicleListPanel() {
        this.isvehiclepanelopen = true;
        this.vehiclepanelopen = 'list';
      },
      closeVehiclePopup(event) {
        // console.log(event.target.closest('.dialog-vehicle-messages'));
        // Do not close popup if interacting with anything within the messages popup

        // if (event.target.classList.length > 0) {
        //   if (event.target.className.match(/\bdialog-vehicle-messages\b/) || event.target.className.match(/\bbackdrop\b/) || event.target.closest('.dialog-vehicle-messages') != undefined) { 
        //     return;
        //   } 
        // }

        let currentclass = event.target.getAttribute("class");

        if (currentclass != '') {
          if (currentclass === 'dialog-vehicle-messages' || currentclass === 'backdrop' || event.target.closest('.dialog-vehicle-messages') != undefined) {
            return;
          }
        }

        if (event.target.closest('.search__button--start') != undefined) {
          if (!event.target.closest('.search__button--start').className.match(/\bsearch__button--start\b/)) {
            // Check if this is a child element of the search button
            if (!event.target.className.match(/\bsearch__button--start\b/)) { 
              // Check if this is not the actual search button
              this.isvehiclepanelopen = false;
            }
          }
        } else {
          this.isvehiclepanelopen = false;
        }
      },
      closeMailingFormPopup(event) {
        let currentclass = event.target.getAttribute("class");

        if (currentclass != '') {
          if (currentclass === 'dialog-vehicle-messages' || currentclass === 'backdrop' || event.target.closest('.dialog-vehicle-messages') != undefined) {
            return;
          }
        }

        if (event.target.closest('.search__button--start') != undefined) {
          if (!event.target.closest('.search__button--start').className.match(/\bsearch__button--start\b/)) {
            // Check if this is a child element of the search button
            if (!event.target.className.match(/\bsearch__button--start\b/)) { 
              // Check if this is not the actual search button
              this.ismailingformopen = false;
            }
          }
        } else {
          this.ismailingformopen = false;
        }
      },
      closePanel() {
        this.isvehiclepanelopen = false;
      },

      cancelSavedVehicles() {
        this.vehiclepanelopen = 'search';
      },

      searchNewParts() {

        if(this.storeCatalog == 'WHI'){
          // clear the categories on the state to go to /select-parts-drilldown page
          this.$store.dispatch('vehicle/setSelectedCategories', []);
          this.$emit('selectedVehicleComplete');
        }

        this.isvehiclepanelopen = false;
        this.searchParts();
      },

      plink_model(pmodel){
        // console.log(pmodel);
        this.selectedmodel = pmodel.model;
        this.selectedmake = pmodel.make;
        // this.searchNewParts();
      },

      clearPlink() {
        if(this.storeCatalog == 'PARTSLINK'){
          this.$refs.plink_autocomplete.clearInput();
        }
      }

  },
  computed: {
      ...mapGetters([
          "userIsAuthenticated",
          "storeCatalog",
          "appInitialiazed",
          "storeConfigID",
          "storefront"
      ]),
      ...mapGetters('api', [
          "catclass",
      ]),
      ...mapGetters('system', [
          "erppartition",
          "language"
      ]),
      catalogCaption() {
        return 'Search ' + this.catclass + ' Catalog';
        // if (this.storeCatalog == 'WHI'){
        //   return 'Search ' + this.catclass + ' Catalog';
        // }

        // if (this.storeCatalog == 'PARTSLINK'){
        //   return 'Search Partslink Catalog';
        // }
        
        // return '';
      },
      mailingFormButtonClass() {
        return this.ismailingformopen ? "search__button--hover" : "";
      },

      vehicleSearchButtonClass() {
        return this.isvehiclepanelopen ? "search__button--hover" : "";
      },
      vehicleSearchContainerClass() {
        return this.isvehiclepanelopen ? "search__dropdown--open" : "";
      },
      vehicleSearchPanelClass() {
        return this.vehiclepanelopen === 'search' ? "vehicle-picker__panel--active" : "";
      },
      vehicleListPanelClass() {
        return this.vehiclepanelopen === 'list' ? "vehicle-picker__panel--active" : "";
      },

      searchstr_placeholder() {
        if(this.storeCatalog == 'WHI'){
          return 'Enter VIN number';
        }

        if (this.storeCatalog == 'PARTSLINK'){
          return 'Part Search';
        }

        return '';
      },

      header_text() {
        if(this.storefront){
        //   return sfCustom[this.storefront].header_text;  
          return process.env.VUE_HEADER_TEXT;
        }
        return '';
      },

      has_search_vehicle() {
        if(this.storefront){
        //   return sfCustom[this.storefront].search_vehicle;
          return process.env.VUE_SEARCH_VEHICLE;
        }
        return false;
      },

      has_mailing_form() {
        if(this.storefront){
        //   return sfCustom[this.storefront].mailing_form;
          return process.env.VUE_MAILING_FORM;
        }
        return false;
      },
  },
  watch: {
    userIsAuthenticated(newVal) {
      this.searchkeyword = '';
      // user means logout
      if (!newVal){
        // clear the value of the dropdowns
        this.selectedyear = '';
        this.selectedmake = '';
        this.selectedmodel = '';
        this.selectedengine = '';
      }
    },
    vehiclewasselected(newVal) {
      if (newVal) {
        this.isvehiclepanelopen = false, this.vehiclewasselected = false;
      }
    },
    appInitialiazed(newVal) {
      if(newVal == true){
        this.getYears();
      }
    },
  },
  created() {
    // this.getYears();
    if(this.appInitialiazed == true){
      this.getYears();
    }
  },
  updated() {
    console.log('updated header search');
    // console.log(this.captionYear);
  }
}

</script>